module.exports = __webpack_public_path__ + "img/es.f3cef83c.svg";